import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function CostManagementPage() {
  return (
    <SectionLayout title="Cost Management">
      {/* Cost management content will go here */}
    </SectionLayout>
  );
} 